const ACTIVE_IMAGE_DOWNLOAD_LAYERS = {
  altimetry: "altimetry",
  "soil-map": "soil_map",
  soil_map: "soil_map",
  "yield-map": "yield_map",
  yield_map: "yield_map",
};

const VISUAL_DOWNLOAD_LAYERS = new Set([
  "altimetry",
  "soil_map",
  "yield_map",
]);

export const getDefaultDownloadLayer = ({ activeImageType, options = [] }) => {
  const enabledOptions = options.filter((option) => option.enabled !== false);
  const preferredLayer = ACTIVE_IMAGE_DOWNLOAD_LAYERS[activeImageType];

  if (
    preferredLayer &&
    enabledOptions.some((option) => option.value === preferredLayer)
  ) {
    return preferredLayer;
  }

  return enabledOptions[0]?.value || null;
};

export const getDefaultDownloadFormat = ({ layer, options = [] }) => {
  if (
    VISUAL_DOWNLOAD_LAYERS.has(layer) &&
    options.some((option) => option.value === "PNG")
  ) {
    return "PNG";
  }

  return options[0]?.value || null;
};
